export default "__VITE_ASSET__C75b7ipD__"